import * as React from "react";
import { SVGProps } from "react";

const Klaytn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 1975" {...props}>
    <path
      fill="#4f473b"
      d="m1047.4 982.5 683.3 678.3c359.1-380.9 359.1-975.7 0-1356.6m-733.2 723.2-673.3 668.3L997.5 1975l673.3-279.3M972.6 957.6l698.3-693.3L1027.4 0 389 1541.2l583.6-583.6zM0 982.5c-.5 252.3 95.9 495.1 269.3 678.3l668.3-1611"
    />
  </svg>
);

export default Klaytn;
